import { useTranslation } from 'react-i18next'
import { useModalOpened } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import Tooltip from '~/components/Tooltip'
import { Row, StyledLabel, StyledDiscountedButton } from './styled'

const TradeFeeWrapper: React.FC = () => {
  const { t } = useTranslation()
  const isPreviewOpen = useModalOpened(ApplicationModal.LIMIT_ORDER_PREVIEW)

  if (!isPreviewOpen) {
    return null
  }

  return (
    <Row>
      <StyledLabel>{t('trade_fee')}</StyledLabel>
      <Tooltip placement="right" title={t('lo_trade_fee_tip')} trigger="hover">
        <StyledDiscountedButton>{t('free')}</StyledDiscountedButton>
      </Tooltip>
    </Row>
  )
}

export default TradeFeeWrapper
